// import React, { useEffect, useState } from "react";
// import { colors, Makelabel, setLocalStorageItem, getLocalStorageItem } from "../../../Utils/Index";
// import CommonInput from "../../../Components/CommonInput";
// import CommonButton from "../../../Components/CommonButton";
// import { CreateGroupOrder, CreateOrder, fetchOrderGroupSummery, finalizeGroupOrder, RestaurentOrderRegister } from "../../../ApiService/Apis/order/order";
// import { triggerSnackbar } from "../../../Services/NotificationService";
// import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
// import { CustomerRegister } from "../../../ApiService/Apis/Auth/Auth";
// import OtpModal from "../../Auth/OtpModal";
// import { IoArrowBack } from "react-icons/io5";
// import { ImageUrl } from "../../../ApiService/Axios/Index";
// import { message } from "antd";

// const OrderDetailLeftPanel = ({
//   setOrdereditems,
//   selectedTable,
//   openOtpModal,
//   selectedTableNumber,
//   orderedItems,
//   setOpen,
//   setOpenOtpModal,
//   otpData,
//   setOtpData,
//   orderType,
//   OrderData,
//   ApiCall,
//   setOptionModal,
//   open

// }) => {
//   const location = useLocation();
//   const [params] = useSearchParams();
//   const navigate = useNavigate();
//   const [fieldDetail, setFieldDetail] = useState({
//     foodInstruction: "",
//     mobile: "",
//     customerName: "",
//   });

//   const [btnLoading, setBtnLoading] = useState(false);
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const sessionId = getLocalStorageItem("sessionId");
//   const customerId = getLocalStorageItem("customerId");
//   const [showJoinGroupModal, setShowJoinGroupModal] = useState(false);
//   const clearGroupSession = () => {
//     localStorage.removeItem("sessionId");
//     localStorage.removeItem("customerId");
//     setSummary(null);
//     setShowJoinGroupModal(true); // prompt user to join again
//   };

//   useEffect(() => {
//     setLoading(true);
//     fetchOrderGroupSummery(sessionId)
//       .then((res) => {
//         const expiresAt = res?.data?.session?.expiresAt;
//         if (expiresAt && new Date(expiresAt).getTime() < Date.now()) {
//           triggerSnackbar("Your group session has expired", "error");
//           clearGroupSession();
//           return;
//         }
//         setSummary(res?.data || {});
//       })
//       .catch((err) => {
//         console.error("Error fetching group summary:", err);
//         setError("Failed to load order summary");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [OrderData, ApiCall]);

//   const isLeader = customerId == summary?.session?.leaderId;

//   const handleManageQuantity = (type, index) => {
//     let temp = [...orderedItems];
//     if (type === "add") {
//       temp[index] = { ...temp[index], quantity: temp[index].quantity + 1 };
//     } else if (type === "subtract") {
//       if (temp[index].quantity > 1) {
//         temp[index] = { ...temp[index], quantity: temp[index].quantity - 1 };
//       } else if ((temp[index].quantity = 1)) {
//         temp = [
//           ...temp.slice(0, index), // Include all varientList before the index
//           ...temp.slice(index + 1), // Include all varientList after the index
//         ];
//       }
//     }
//     setOrdereditems(temp);
//   };

//   const payload = {
//     tableId: selectedTable,
//     items: orderedItems.map((i) => {
//       return {
//         foodId: i.foodId,
//         foodVariant: i?.foodVariant,
//         quantity: i.quantity,
//       };
//     }),
//     customerName: fieldDetail.customerName,
//     kitchenInstruction: fieldDetail.foodInstruction,
//     restaurantId: Number(params?.getAll("restaurantId")[0]) || getLocalStorageItem("userDetail")?.restaurantId,
//   };
//   const handlePlaceOrder = (data) => {
//     let temp = { ...payload };
//     const restaurentRegisterData = {
//       mobileNumber: String(fieldDetail.mobile),
//       customerName: fieldDetail.customerName,
//       restaurantId: Number(params?.getAll("restaurantId")[0]) || getLocalStorageItem("userDetail")?.restaurantId,
//     }
//     setBtnLoading(true);
//     RestaurentOrderRegister(restaurentRegisterData).then((res) => {
//       if (res.status === "success") {
//         setLocalStorageItem("access_token", res?.data?.accessToken);
//         setLocalStorageItem("customerId", res?.data?.user?.userId);
//         if (localStorage.getItem("access_token")) {
//           let temp = { ...payload };
//           temp["customerId"] = Number(localStorage.getItem("customerId") || OrderData?.customerId);
//           CreateOrder(temp)
//             .then((res) => {
//               if (res.status === "success") {
//                 triggerSnackbar(res.message, "success");
//                 setOrdereditems([]);
//                 setBtnLoading(false);
//                 // setOpenOtpModal(false);
//                 setOpen(false);
//                 setFieldDetail({
//                   foodInstruction: "",
//                   mobile: "",
//                   customerName: "",
//                 });
//                 if (location.pathname?.includes("customer")) {
//                   navigate("/customer/current-order");
//                   // window.location.reload();
//                 }
//               }
//             })
//             .catch((err) => console.log(err))
//             .finally(() => setBtnLoading(false));
//         }
//       } else {
//         message.error(res.message);
//       }
//     }).catch((err)=>{
//       console.log(err);
//     }).finally(()=>{
//       setBtnLoading(false);
//     })

//   };

//   const handlePlaceGroupOrder = (data) => {
//     const CreateGroupOrderData = {
//       sessionId: sessionId,
//       customerId: customerId,
//       items: orderedItems.map((i) => {
//         return {
//           foodId: i.foodId,
//           foodVariant: i?.foodVariant,
//           quantity: i.quantity,
//         };
//       }),
//       action: "add",
//     }
//     setBtnLoading(true);
//     CreateGroupOrder(CreateGroupOrderData).then((res) => {
//       if (res.status === "success") {
//         triggerSnackbar(res.message, "success");
//         const temp = {
//           kitchenInstruction: fieldDetail.foodInstruction,
//           customerId: customerId,
//           sessionId: sessionId,
//         };
//         finalizeGroupOrder(temp)
//           .then((res) => {
//             if (res.status === "success") {
//               triggerSnackbar(res.message, "success");
//               setOrdereditems([]);
//               setBtnLoading(false);
//               setOpen(false);
//               setFieldDetail({
//                 foodInstruction: "",
//                 mobile: "",
//                 customerName: "",
//               });
//               navigate("/customer/current-order");
//             }
//           })
//           .catch((err) => console.log(err))
//           .finally(() => setBtnLoading(false));
//       } else {
//         message.error(res.message);
//       }
//     }).catch((err) => console.log(err)).finally((ApiCall) => setBtnLoading(false));
//   };
//   // const handlePlaceGroupOrder = (data) => {
//   //   let temp = { ...payload };
//   //   temp["customerId"] = OrderData?.customerId;
//   //   temp["sessionId"] = OrderData?.sessionId;
//   //   finalizeGroupOrder(temp)
//   //     .then((res) => {
//   //       if (res.status === "success") {
//   //         triggerSnackbar(res.message, "success");
//   //         setOrdereditems([]);
//   //         setBtnLoading(false);
//   //         setOpen(false);
//   //         setFieldDetail({
//   //           foodInstruction: "",
//   //           mobile: "",
//   //           customerName: "",
//   //         });
//   //         if (location.pathname?.includes("customer")) {
//   //           navigate("/customer/current-order");
//   //         }
//   //       }
//   //     })
//   //     .catch((err) => console.log(err))
//   //     .finally(() => setBtnLoading(false));
//   // };



//   // const createOrder = () => {
//   //   console.log("hsedhfhiohisod", selectedTable, orderedItems, fieldDetail);
//   //   if (selectedTable && orderedItems.length > 0 && fieldDetail.customerName) {
//   //     setBtnLoading(true);
//   //     if (location.pathname?.includes("customer")) {
//   //       CustomerRegister({
//   //         mobileNumber: fieldDetail.mobile,
//   //         restaurantId: Number(params?.getAll("restaurantId")[0]),
//   //       })
//   //         .then((res) => {
//   //           if (res.status === "success") {
//   //             setOtpData(res.data);
//   //             setOpenOtpModal(true);
//   //           }
//   //         })
//   //         .catch((err) => console.log(err));
//   //     } else {
//   //       orderType == "group" ? handlePlaceGroupOrder(payload) : handlePlaceOrder(payload)
//   //     }
//   //   }
//   // };

//   return (
//     <>
//       {orderType == "group" ?
//         <div className="relative h-full">
//           {/* Back Button */}
//           <div
//             onClick={() => setOpen(false)}
//             className="flex lg:hidden text-dynmaicText justify-start gap-3 cursor-pointer text-lg font-semibold items-center"
//           >
//             <IoArrowBack /> Back
//           </div>

//           {/* Table Info */}
//           <div className="text-dynmaicText mt-4 font-bold font-inter">
//             <p className="text-xl">Table No. {selectedTableNumber}</p>
//             <p className="text-sm font-normal mt-1 text-gray-400">
//               Code: {summary?.session?.sessionCode} | Status:{" "}
//               <span className="text-green-700">{summary?.session?.status}</span>
//             </p>
//             <p className="text-sm font-normal mt-1 text-gray-400">
//               Capacity: {summary?.session?.table?.table_capacity}
//             </p>
//             <p className="text-sm font-normal mt-1 text-gray-400">
//               Leader ID: {summary?.session?.leader?.id}
//             </p>
//             <p className="text-sm font-normal mt-1 text-gray-400">
//               Expires At: {new Date(summary?.session?.expiresAt).toLocaleString()}
//             </p>
//             <div className="w-1/4 h-1 mt-2 bg-brand"></div>
//           </div>

//           {/* Participants */}
//           <div className="mt-6">
//             <h3 className="text-dynmaicText font-semibold">Participants</h3>
//             <div className="flex flex-wrap gap-2 mt-2">
//               {summary?.participants?.map((p, index) => (
//                 <span
//                   key={p.id}
//                   className="px-3 py-1 text-sm bg-gray-700 text-white rounded-full"
//                 >
//                   {p.customer?.customerName || `Customer #${index + 1}`}
//                 </span>
//               ))}
//             </div>
//           </div>

//           {orderedItems?.length > 0 ? (
//             <div className="max-h-[1/4] overflow-y-scroll">
//               {orderedItems.map((i, index) => {
//                 return (
//                   <>
//                     <div
//                       key={index}
//                       className="grid grid-cols-3 place-items-start place-content-center items-center mt-4 font-inter text-dynmaicText gap-3"
//                     >
//                       <div>
//                         <p className="font-bold text-[13px]">{i?.foodName} </p>
//                         <p className="text-xs capitalize font-poppins mt-1">
//                           ({i.foodVariant})
//                         </p>
//                       </div>
//                       <p className="text-center">
//                         ₹ {(i.price + i.basePrice) * i.quantity}
//                       </p>
//                       <div className="flex justify-center text-dynmaicText font-bold items-center gap-3">
//                         <p
//                           onClick={() => handleManageQuantity("subtract", index)}
//                           className="bg-red-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold "
//                         >
//                           -
//                         </p>
//                         <p className="text-dynmaicText">{i?.quantity}</p>
//                         <p
//                           onClick={() => handleManageQuantity("add", index)}
//                           className="bg-green-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold "
//                         >
//                           +
//                         </p>
//                       </div>
//                     </div>
//                     {index !== orderedItems.length - 1 && (
//                       <hr className="mt-3 border border-dashed border-gray-400" />
//                     )}
//                   </>
//                 );
//               })}
//             </div>
//           ) : (
//             <p className="flex justify-center items-center text-dynmaicText font-inter mt-10">
//               No food added yet
//             </p>
//           )}
//           <div className="mt-6">{Makelabel("Food Instruction (Optional)")}</div>
//           <div className="mt-2">
//             <CommonInput
//               onChange={(e) =>
//                 setFieldDetail({
//                   ...fieldDetail,
//                   foodInstruction: e.target.value,
//                 })
//               }
//               value={fieldDetail.foodInstruction}
//               placeholder={"Enter Instruction"}
//             />
//           </div>
//           {/* Group Customer Items (from API) */}
//           {/* <div className="mt-6">
//             <h3 className="text-dynmaicText font-semibold">Group Items</h3>
//             <div className="max-h-[300px] overflow-y-auto pr-2 mt-2 custom-scrollbar">
//               {Object.keys(summary?.customerItems || {}).map((custId, index) => (
//                 <div key={custId} className="mt-4">
//                   <p className="text-green-400 font-medium mb-2">
//                     {summary.customerItems[custId][0]?.customer?.customerName ||
//                       `Customer #${index + 1}`}
//                   </p>
//                   {summary.customerItems[custId].map((item) => (
//                     <div
//                       key={item.id}
//                       className="grid grid-cols-3 items-center text-dynmaicText text-sm bg-gray-800 p-3 rounded-lg mb-2"
//                     >
//                       <div>
//                         <p className="font-semibold">{item.variant}</p>
//                         <p className="text-xs text-gray-400">Qty: {item.quantity}</p>
//                       </div>
//                       <p className="text-center">₹ {Number(item.totalPrice || 0).toFixed(2)}</p>
//                       <p
//                         className={`text-xs text-center ${item.isConfirmed ? "text-green-400" : "text-yellow-400"
//                           }`}
//                       >
//                         {item.isConfirmed ? "Confirmed" : "Pending"}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div> */}


//           {/* <div className="mt-6">{Makelabel("Food Instruction (Optional)")}</div>
//           <div className="mt-2">
//             <CommonInput
//               onChange={(e) =>
//                 setFieldDetail({
//                   ...fieldDetail,
//                   foodInstruction: e.target.value,
//                 })
//               }
//               value={fieldDetail.foodInstruction}
//               placeholder={"Enter Instruction"}
//             />
//           </div>
//           {location.pathname?.includes("customer") && (
//             <>
//               <div className="mt-6">{Makelabel("Mobile Number")}</div>
//               <div className="mt-2">
//                 <CommonInput
//                   onInput={(e) => {
//                     const value = e.target.value.replace(/\D/g, "");
//                     e.target.value = value;
//                   }}
//                   onChange={(e) =>
//                     setFieldDetail({ ...fieldDetail, mobile: e.target.value })
//                   }
//                   value={fieldDetail.mobile}
//                   placeholder={"Mobile Number"}
//                 />
//               </div>
//             </>
//           )}

//           <div className="mt-6">{Makelabel("Customer Name")}</div>
//           <div className="mt-2">
//             <CommonInput
//               onChange={(e) =>
//                 setFieldDetail({
//                   ...fieldDetail,
//                   customerName: e.target.value,
//                 })
//               }
//               value={fieldDetail.customerName}
//               placeholder={"Customer Name"}
//             />
//           </div> */}

//           {/* Combined Totals */}
//           {/* <div className="mt-8 bg-dynmaicBg rounded-lg p-4 text-dynmaicText font-semibold">
//             <p>Total Items: {summary?.summary?.totalItems ?? 0}</p>
//             <p>Base Price: ₹ {Number(summary?.summary?.totalBasePrice || 0).toFixed(2)}</p>
//             <p>Tax: ₹ {Number(summary?.summary?.totalTax || 0).toFixed(2)}</p>
//             <p className="text-green-400 text-lg mt-2">
//               Total: ₹ {Number(summary?.summary?.totalPriceAfterTax || 0).toFixed(2)}
//             </p>
//           </div> */}


//           {/* Buttons */}
//           <div className="mt-6 flex justify-center gap-4">
//             <CommonButton
//               onClick={() => setOrdereditems([])}
//               text={"Discard All"}
//               color={colors.red}
//             />
//             <CommonButton
//               loading={btnLoading}
//               onClick={() => { orderType == "group" ? handlePlaceGroupOrder(payload) : handlePlaceOrder(payload) }}
//               text={"Place Order"}
//               color={colors.green}
//             // disabled={!isLeader}
//             />
//           </div>
//         </div>
//         :

//         <div className="relative h-full ">
//           <div
//             onClick={() => setOpen(false)}
//             className="flex lg:hidden text-dynmaicText justify-start gap-3 cursor-pointer text-lg font-semibold items-center"
//           >
//             <IoArrowBack /> Back
//           </div>
//           <div className="text-dynmaicText mt-4 font-bold font-inter">
//             <p className="text-xl">Table No. {selectedTableNumber}</p>
//             <div className="w-1/4 h-1 mt-1 bg-brand"></div>
//           </div>
//           {orderedItems?.length > 0 ? (
//             <div className="max-h-[1/4] overflow-y-scroll">
//               {orderedItems.map((i, index) => {
//                 return (
//                   <>
//                     <div
//                       key={index}
//                       className="grid grid-cols-3 place-items-start place-content-center items-center mt-4 font-inter text-dynmaicText gap-3"
//                     >
//                       <div>
//                         <p className="font-bold text-[13px]">{i?.foodName} </p>
//                         <p className="text-xs capitalize font-poppins mt-1">
//                           ({i.foodVariant})
//                         </p>
//                       </div>
//                       <p className="text-center">
//                         ₹ {(i.price + i.basePrice) * i.quantity}
//                       </p>
//                       <div className="flex justify-center text-dynmaicText font-bold items-center gap-3">
//                         <p
//                           onClick={() => handleManageQuantity("subtract", index)}
//                           className="bg-red-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold "
//                         >
//                           -
//                         </p>
//                         <p className="text-dynmaicText">{i?.quantity}</p>
//                         <p
//                           onClick={() => handleManageQuantity("add", index)}
//                           className="bg-green-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold "
//                         >
//                           +
//                         </p>
//                       </div>
//                     </div>
//                     {index !== orderedItems.length - 1 && (
//                       <hr className="mt-3 border border-dashed border-gray-400" />
//                     )}
//                   </>
//                 );
//               })}
//             </div>
//           ) : (
//             <p className="flex justify-center items-center text-dynmaicText font-inter mt-10">
//               No food added yet
//             </p>
//           )}
//           <div className="mt-6">{Makelabel("Food Instruction (Optional)")}</div>
//           <div className="mt-2">
//             <CommonInput
//               onChange={(e) =>
//                 setFieldDetail({
//                   ...fieldDetail,
//                   foodInstruction: e.target.value,
//                 })
//               }
//               value={fieldDetail.foodInstruction}
//               placeholder={"Enter Instruction"}
//             />
//           </div>

//           <div className="mt-6">{Makelabel("Mobile Number")}</div>
//           <div className="mt-2">
//             <CommonInput
//               onInput={(e) => {
//                 const value = e.target.value.replace(/\D/g, "");
//                 e.target.value = value;
//               }}
//               onChange={(e) =>
//                 setFieldDetail({ ...fieldDetail, mobile: e.target.value })
//               }
//               value={fieldDetail.mobile}
//               placeholder={"Mobile Number"}
//             />
//           </div>


//           <div className="mt-6">{Makelabel("Customer Name")}</div>
//           <div className="mt-2">
//             <CommonInput
//               onChange={(e) =>
//                 setFieldDetail({
//                   ...fieldDetail,
//                   customerName: e.target.value,
//                 })
//               }
//               value={fieldDetail.customerName}
//               placeholder={"Customer Name"}
//             />
//           </div>

//           <div className="mt-20 w-full font-inter">
//             <div className="bg-dynmaicBg2 text-end p-2 mb-3 font-semibold text-dynamicText ">
//               <p>
//                 Tax ₹{" "}
//                 {orderedItems?.reduce((a, b) => {
//                   a = a + ((b.quantity * (b.price + b.basePrice)) * b.totalTax / 100);
//                   return a;
//                 }, 0)?.toFixed(0)}
//               </p>
//               <p>
//                 Amount To Pay ₹{" "}
//                 {(orderedItems?.reduce((a, b) => {
//                   a = a + b.quantity * (b.price + b.basePrice);
//                   return a;
//                 }, 0) + orderedItems?.reduce((a, b) => {
//                   a = a + ((b.quantity * (b.price + b.basePrice)) * b.totalTax / 100);
//                   return a;
//                 }, 0))?.toFixed(2)}
//               </p>
//             </div>
//             <div className=" flex justify-center items-center w-full  gap-4">
//               <CommonButton
//                 onClick={() => setOrdereditems([])}
//                 text={"Discard All"}
//                 color={colors.red}
//               />
//               <CommonButton
//                 loading={btnLoading}
//                 onClick={() => { orderType == "group" ? handlePlaceGroupOrder(payload) : handlePlaceOrder(payload) }}
//                 text={"Place Order"}
//                 color={colors.green}
//               />
//             </div>
//           </div>
//         </div>
//       }





//       {openOtpModal && (
//         <OtpModal
//           open={openOtpModal}
//           otpData={otpData}
//           setOpen={setOpenOtpModal}
//           callbackApi={orderType == "group" ? handlePlaceGroupOrder : handlePlaceOrder}
//         />
//       )}
//     </>
//   );
// };

// export default OrderDetailLeftPanel;


import React, { useEffect, useState } from "react";
import { colors, Makelabel, setLocalStorageItem, getLocalStorageItem } from "../../../Utils/Index";
import CommonInput from "../../../Components/CommonInput";
import CommonButton from "../../../Components/CommonButton";
import { CreateGroupOrder, CreateOrder, fetchOrderGroupSummery, finalizeGroupOrder, RestaurentOrderRegister } from "../../../ApiService/Apis/order/order";
import { triggerSnackbar } from "../../../Services/NotificationService";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { CustomerRegister } from "../../../ApiService/Apis/Auth/Auth";
import OtpModal from "../../Auth/OtpModal";
import { IoArrowBack } from "react-icons/io5";
import { ImageUrl } from "../../../ApiService/Axios/Index";
import { message } from "antd";
import UseSocket from "../../../Hooks/UseSocket";
import CurrentOrder from "../../Customer/CurrentOrder";

const OrderDetailLeftPanel = ({
  setOrdereditems,
  selectedTable,
  openOtpModal,
  selectedTableNumber,
  orderedItems,
  setOpen,
  setOpenOtpModal,
  otpData,
  setOtpData,
  orderType,
  OrderData,
  ApiCall,
  setOptionModal,
  open

}) => {
  const location = useLocation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [fieldDetail, setFieldDetail] = useState({
    foodInstruction: "",
    mobile: "",
    customerName: "",
  });

  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const sessionId = getLocalStorageItem("sessionId");
  const customerId = getLocalStorageItem("customerId");
  const [showJoinGroupModal, setShowJoinGroupModal] = useState(false);
  const clearGroupSession = () => {
    localStorage.removeItem("sessionId");
    localStorage.removeItem("customerId");
    setSummary(null);
    setShowJoinGroupModal(true); // prompt user to join again
  };

  const { socket } = UseSocket("customer");
  useEffect(() => {
    if (!socket || !sessionId) return;

    socket.emit("join_group_session", {
      sessionId,
    });

    console.log("Joined group session:", sessionId);

    return () => {
      socket.emit("leave_group_session", {
        sessionId,
      });
    };
  }, [socket, sessionId]);
  const fetchSummary = () => {
    if (!sessionId) return;

    setLoading(true);

    fetchOrderGroupSummery(sessionId)
      .then((res) => {
        const expiresAt = res?.data?.[0]?.expiresAt;
        if (expiresAt && new Date(expiresAt).getTime() < Date.now()) {
          triggerSnackbar("Your group session has expired", "error");
          clearGroupSession();
          return;
        }
        setSummary(res.data || {});
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchSummary();
  }, [OrderData, ApiCall]);

  useEffect(() => {
    if (!socket) return;

    socket.on("group_item_added", (data) => {
      console.log("group_item_added", data);
      fetchSummary();
    });

    socket.on("group_item_updated", (data) => {
      console.log("group_item_updated", data);
      fetchSummary();
    });

    socket.on("group_item_removed", (data) => {
      console.log("group_item_removed", data);
      fetchSummary();
    });

    socket.on("group_items_cleared", (data) => {
      console.log("group_items_cleared", data);
      fetchSummary();
    });

    socket.on("group_participant_joined", (data) => {
      console.log("group_participant_joined", data);
      fetchSummary();
    });

    socket.on("group_participant_left", (data) => {
      console.log("group_participant_left", data);
      fetchSummary();
    });

    return () => {
      socket.off("group_item_added");
      socket.off("group_item_updated");
      socket.off("group_item_removed");
      socket.off("group_items_cleared");
      socket.off("group_participant_joined");
      socket.off("group_participant_left");
    };
  }, [socket]);

  const isLeader = Number(customerId) === Number(summary?.[0]?.leader?.id);
  const handleManageQuantity = (type, index) => {
    let temp = [...orderedItems];
    if (type === "add") {
      temp[index] = { ...temp[index], quantity: temp[index].quantity + 1 };
    } else if (type === "subtract") {
      if (temp[index].quantity > 1) {
        temp[index] = { ...temp[index], quantity: temp[index].quantity - 1 };
      } else if ((temp[index].quantity = 1)) {
        temp = [
          ...temp.slice(0, index),
          ...temp.slice(index + 1),
        ];
      }
    }
    setOrdereditems(temp);
  };

  const isCustomerSide = window.location.hash.includes("order-by-customer");
  const payload = {
    tableId: selectedTable,
    items: orderedItems.map((i) => {
      return {
        foodId: i.foodId,
        foodVariant: i?.foodVariant,
        quantity: i.quantity,
      };
    }),
    kitchenInstruction: fieldDetail.foodInstruction,
    restaurantId: Number(params?.getAll("restaurantId")[0]) || getLocalStorageItem("userDetail")?.restaurantId,
    ...(isCustomerSide && {
      customerName:
        fieldDetail.customerName ||
        getLocalStorageItem("customerName"),
    }),
  };
  const handlePlaceOrder = (data) => {
    const token = getLocalStorageItem("access_token");
    if (!token) {
      if (fieldDetail.mobile.length !== 10) {
        message.error("Please enter a valid 10-digit mobile number");
        return;
      }

      if (
        fieldDetail.customerName.trim().length < 2 ||
        fieldDetail.customerName.trim().length > 15
      ) {
        message.error("Customer name must be between 2 and 15 characters");
        return;
      }
    }

    const createOrderPayload = () => {
      const orderPayload = {
        ...payload,
        customerId: Number(
          getLocalStorageItem("customerId") || customerId
        ),
      };

      setBtnLoading(true);

      CreateOrder(orderPayload)
        .then((res) => {
          if (res.status === "success") {
            triggerSnackbar(res.message, "success");
            setOrdereditems([]);
            setOpen(false);

            setFieldDetail({
              foodInstruction: "",
              mobile: "",
              customerName: "",
            });

            if (location.pathname.includes("customer")) {
              navigate("/customer/current-order");
            }
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setBtnLoading(false));
    };

    // If already logged in, skip registration
    if (token) {
      createOrderPayload();
      return;
    }

    // Register first-time customer
    const restaurentRegisterData = {
      mobileNumber: fieldDetail.mobile,
      customerName: fieldDetail.customerName,
      restaurantId:
        Number(params?.get("restaurantId")) ||
        getLocalStorageItem("userDetail")?.restaurantId,
    };

    setBtnLoading(true);

    RestaurentOrderRegister(restaurentRegisterData)
      .then((res) => {
        if (res.status === "success") {
          setLocalStorageItem("access_token", res.data.accessToken);
          setLocalStorageItem("customerId", res.data.user.userId);
          setLocalStorageItem("customerName", res.data.user.customerName);
          setLocalStorageItem("mobileNumber", res.data.user.mobileNumber);
          setLocalStorageItem("role", res.data.role);

          createOrderPayload();
        } else {
          message.error(res.message);
          setBtnLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setBtnLoading(false);
      });
  };

  // const handlePlaceGroupOrder = (data) => {
  //   const CreateGroupOrderData = {
  //     sessionId: sessionId,
  //     customerId: customerId,
  //     items: orderedItems.map((i) => {
  //       return {
  //         foodId: i.foodId,
  //         foodVariant: i?.foodVariant,
  //         quantity: i.quantity,
  //       };
  //     }),
  //     action: "add",
  //   }
  //   setBtnLoading(true);
  //   CreateGroupOrder(CreateGroupOrderData).then((res) => {
  //     if (res.status === "success") {
  //       triggerSnackbar(res.message, "success");
  //       const temp = {
  //         kitchenInstruction: fieldDetail.foodInstruction,
  //         customerId: customerId,
  //         sessionId: sessionId,
  //       };
  //       finalizeGroupOrder(temp)
  //         .then((res) => {
  //           if (res.status === "success") {
  //             triggerSnackbar(res.message, "success");
  //             setOrdereditems([]);
  //             setBtnLoading(false);
  //             setOpen(false);
  //             setFieldDetail({
  //               foodInstruction: "",
  //               mobile: "",
  //               customerName: "",
  //             });
  //             navigate("/customer/current-order");
  //           }
  //         })
  //         .catch((err) => console.log(err))
  //         .finally(() => setBtnLoading(false));
  //     } else {
  //       message.error(res.message);
  //     }
  //   }).catch((err) => console.log(err)).finally((ApiCall) => setBtnLoading(false));
  // };
  const handleAddToGroupOrder = () => {
    if (!orderedItems?.length) return;

    const CreateGroupOrderData = {
      sessionId,
      customerId,
      items: orderedItems.map((i) => ({
        foodId: i.foodId,
        foodVariant: i?.foodVariant,
        quantity: i.quantity,
      })),
      action: "add",
    };

    setBtnLoading(true);
    CreateGroupOrder(CreateGroupOrderData)
      .then((res) => {
        if (res.status === "success") {
          triggerSnackbar(res.message, "success");
          setOrdereditems([]); // clear local draft, item now lives in shared summary
          fetchSummary();      // refresh immediately for this browser
          // other browsers refresh via the "group_item_added" socket event
        } else {
          message.error(res.message);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  // Only the leader finalizes the whole session and sends it to the kitchen
  const handleFinalizeGroupOrder = () => {
    const temp = {
      kitchenInstruction: fieldDetail.foodInstruction,
      customerId,
      sessionId,
    };

    setBtnLoading2(true);
    finalizeGroupOrder(temp)
      .then((res) => {
        if (res.status === "success") {
          triggerSnackbar(res.message, "success");
          setOrdereditems([]);
          setOpen(false);
          setFieldDetail({ foodInstruction: "", mobile: "", customerName: "" });
          navigate("/customer/current-order");
        } else {
          message.error(res.message);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading2(false));
  };

  return (
    <>
      {orderType == "group" ?
        <div className="relative h-full">
          {/* Back Button */}
          <div
            onClick={() => setOpen(false)}
            className="flex lg:hidden text-dynmaicText justify-start gap-3 cursor-pointer text-lg font-semibold items-center"
          >
            <IoArrowBack /> Back
          </div>

          {/* Table Info */}
          <div className="text-dynmaicText mt-4 font-bold font-inter">
            <p className="text-xl">Table No. {selectedTableNumber}</p>
            <p className="text-sm font-normal mt-1 text-gray-400">
              Code: {summary?.session?.sessionCode} | Status:{" "}
              <span className="text-green-700">{summary?.session?.status}</span>
            </p>
            <p className="text-sm font-normal mt-1 text-gray-400">
              Capacity: {summary?.session?.table?.table_capacity}
            </p>
            <p className="text-sm font-normal mt-1 text-gray-400">
              Leader ID: {summary?.session?.leader?.id}
            </p>
            <p className="text-sm font-normal mt-1 text-gray-400">
              Expires At: {new Date(summary?.session?.expiresAt).toLocaleString()}
            </p>
            <div className="w-1/4 h-1 mt-2 bg-brand"></div>
          </div>

          {/* Participants */}
          <div className="mt-6">
            <h3 className="text-dynmaicText font-semibold">Participants</h3>
            <div className="flex flex-wrap gap-2 mt-2">
              {summary?.participants?.map((p, index) => (
                <span
                  key={p.id}
                  className="px-3 py-1 text-sm bg-gray-700 text-white rounded-full"
                >
                  {p.customer?.customerName || `Customer #${index + 1}`}
                </span>
              ))}
            </div>
          </div>

          {orderedItems?.length > 0 ? (
            <div className="max-h-[1/4] overflow-y-scroll">
              {orderedItems.map((i, index) => (
                <>
                  <div key={index} className="grid grid-cols-3 place-items-start place-content-center items-center mt-4 font-inter text-dynmaicText gap-3">
                    <div>
                      <p className="font-bold text-[13px]">{i?.foodName} </p>
                      <p className="text-xs capitalize font-poppins mt-1">({i.foodVariant})</p>
                    </div>
                    <p className="text-center">₹ {(i.price + i.basePrice) * i.quantity}</p>
                    <div className="flex justify-center text-dynmaicText font-bold items-center gap-3">
                      <p onClick={() => handleManageQuantity("subtract", index)} className="bg-red-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold">-</p>
                      <p className="text-dynmaicText">{i?.quantity}</p>
                      <p onClick={() => handleManageQuantity("add", index)} className="bg-green-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold">+</p>
                    </div>
                  </div>
                  {index !== orderedItems.length - 1 && <hr className="mt-3 border border-dashed border-gray-400" />}
                </>
              ))}
            </div>
          ) : (
            <p className="flex justify-center items-center text-dynmaicText font-inter mt-10">No food added yet</p>
          )}

          {/* Shared group cart — everyone's confirmed items, from the server/summary */}
          <div className="mt-6">
            <h3 className="text-dynmaicText font-semibold">Group Items</h3>
            <div className="max-h-[300px] overflow-y-auto pr-2 mt-2 custom-scrollbar">
              {Object.keys(summary?.customerItems || {}).map((custId) => {
                const entry = summary.customerItems[custId];
                const items = entry?.items || [];
                const customerName = entry?.customerName || `Customer #${custId}`;

                if (!items.length) return null;

                return (
                  <div key={custId} className="mt-4">
                    <p className="font-medium mb-2">{customerName}</p>
                    {items.map((item) => (
                      <div
                        key={item.id}
                        className="grid grid-cols-3 items-center text-dynmaicText text-sm bg-gray-800 p-3 rounded-lg mb-2"
                      >
                        <div>
                          <p className="font-semibold text-dynmaicBg2">{item.variant || item.foodVariant}</p>
                          <p className="text-xs text-gray-400">Qty: {item.quantity}</p>
                        </div>
                        <p className="text-center text-dynmaicBg2">₹ {Number(item.totalPrice || 0).toFixed(2)}</p>
                        <p className={`text-xs text-center ${item.isConfirmed ? "text-green-400" : "text-yellow-400"}`}>
                          {item.isConfirmed ? "Confirmed" : "Pending"}
                        </p>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Buttons */}
          <div className="mt-6 flex flex-col gap-3 justify-center">
            <CommonButton onClick={() => setOrdereditems([])} text={"Discard All"} color={colors.red} />

            {/* Everyone (leader + participants) can push their local draft to the shared cart */}
            <CommonButton
              loading={btnLoading}
              onClick={handleAddToGroupOrder}
              text={"Add to Group Order"}
              color={colors.green}
              disabled={!orderedItems?.length}
            />

            {/* Only the leader finalizes and sends everything to the kitchen */}
            {isLeader && (
              <CommonButton
                loading={btnLoading2}
                onClick={handleFinalizeGroupOrder}
                text={"Place Order"}
                color={colors.green}
              // disabled={!summary?.summary?.totalItems}
              />
            )}
          </div>
        </div>
        :

        <div className="relative h-full ">
          <div
            onClick={() => setOpen(false)}
            className="flex lg:hidden text-dynmaicText justify-start gap-3 cursor-pointer text-lg font-semibold items-center"
          >
            <IoArrowBack /> Back
          </div>
          <div className="text-dynmaicText mt-4 font-bold font-inter">
            <p className="text-xl">Table No. {selectedTableNumber}</p>
            <div className="w-1/4 h-1 mt-1 bg-brand"></div>
          </div>
          {orderedItems?.length > 0 ? (
            <div className="max-h-[1/4] overflow-y-scroll">
              {orderedItems.map((i, index) => {
                return (
                  <>
                    <div
                      key={index}
                      className="grid grid-cols-3 place-items-start place-content-center items-center mt-4 font-inter text-dynmaicText gap-3"
                    >
                      <div>
                        <p className="font-bold text-[13px]">{i?.foodName} </p>
                        <p className="text-xs capitalize font-poppins mt-1">
                          ({i.foodVariant})
                        </p>
                      </div>
                      <p className="text-center">
                        ₹ {(i.price + i.basePrice) * i.quantity}
                      </p>
                      <div className="flex justify-center text-dynmaicText font-bold items-center gap-3">
                        <p
                          onClick={() => handleManageQuantity("subtract", index)}
                          className="bg-red-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold "
                        >
                          -
                        </p>
                        <p className="text-dynmaicText">{i?.quantity}</p>
                        <p
                          onClick={() => handleManageQuantity("add", index)}
                          className="bg-green-700 text-dynmaicBg2 cursor-pointer w-6 h-6 flex justify-center items-center font-bold "
                        >
                          +
                        </p>
                      </div>
                    </div>
                    {index !== orderedItems.length - 1 && (
                      <hr className="mt-3 border border-dashed border-gray-400" />
                    )}
                  </>
                );
              })}
            </div>
          ) : (
            <p className="flex justify-center items-center text-dynmaicText font-inter mt-10">
              No food added yet
            </p>
          )}

          {!getLocalStorageItem("access_token") && (
            <>
              <div className="mt-6">{Makelabel("Food Instruction (Optional)")}</div>
              <div className="mt-2">
                <CommonInput
                  onChange={(e) =>
                    setFieldDetail({
                      ...fieldDetail,
                      foodInstruction: e.target.value,
                    })
                  }
                  value={fieldDetail.foodInstruction}
                  placeholder="Enter Instruction"
                />
              </div>

              <div className="mt-6">{Makelabel("Mobile Number")}</div>
              <div className="mt-2">
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    e.target.value = value;
                  }}
                  onChange={(e) =>
                    setFieldDetail({
                      ...fieldDetail,
                      mobile: e.target.value.replace(/\D/g, "").slice(0, 10),
                    })
                  }
                  value={fieldDetail.mobile}
                  maxLength={10}
                  placeholder="Mobile Number"
                />
              </div>

              <div className="mt-6">{Makelabel("Customer Name")}</div>
              <div className="mt-2">
                <CommonInput
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/[^a-zA-Z\s]/g, "")
                      .slice(0, 15);

                    setFieldDetail({
                      ...fieldDetail,
                      customerName: value,
                    });
                  }}
                  value={fieldDetail.customerName}
                  maxLength={15}
                  placeholder="Customer Name"
                />
              </div>
            </>
          )}

          <div className="mt-20 w-full font-inter">
            <div className="bg-dynmaicBg2 text-end p-2 mb-3 font-semibold text-dynamicText ">
              <p>
                Tax ₹{" "}
                {orderedItems?.reduce((a, b) => {
                  a = a + ((b.quantity * (b.price + b.basePrice)) * b.totalTax / 100);
                  return a;
                }, 0)?.toFixed(0)}
              </p>
              <p>
                Amount To Pay ₹{" "}
                {(orderedItems?.reduce((a, b) => {
                  a = a + b.quantity * (b.price + b.basePrice);
                  return a;
                }, 0) + orderedItems?.reduce((a, b) => {
                  a = a + ((b.quantity * (b.price + b.basePrice)) * b.totalTax / 100);
                  return a;
                }, 0))?.toFixed(2)}
              </p>
            </div>
            <div className=" flex justify-center items-center w-full  gap-4">
              <CommonButton
                onClick={() => setOrdereditems([])}
                text={"Discard All"}
                color={colors.red}
              />
              <CommonButton
                loading={btnLoading}
                onClick={() => { orderType == "group" ? handleFinalizeGroupOrder(payload) : handlePlaceOrder(payload) }}
                text={"Place Order"}
                color={colors.green}
              />
            </div>
          </div>
        </div>
      }




      {openOtpModal && (
        <OtpModal
          open={openOtpModal}
          otpData={otpData}
          setOpen={setOpenOtpModal}
          callbackApi={orderType == "group" ? handleAddToGroupOrder : handlePlaceOrder}
        />
      )}
    </>
  );
};

export default OrderDetailLeftPanel;

